/**
 * reads an agency's zoho id, which arrives wrapped as { _value } from the aws
 * agency endpoints and plain from the zoho agent payload
 * @param agency - agency record from either source
 */
export function resolveAgencyId(agency) {
  return agency?.id?._value ?? agency?.id;
}

/**
 * true when the agency being viewed is the logged agent's own one. unknown ids count
 * as "not own", so callers gating a write action stay on the restrictive side
 * @param viewedAgency - agency record currently open in the view
 * @param zohoData - state.user.zohoData of the logged agent
 */
export function isOwnAgency(viewedAgency, zohoData) {
  const viewedId = resolveAgencyId(viewedAgency);
  const ownId = zohoData?.Account_Name?.id;
  if (!viewedId || !ownId) return false;
  return String(viewedId) === String(ownId);
}
